import { LocationNumbersService } from "../../../services"

const liftLocationSuspension = async function(  { commit, state, getters },
  locationId) {
  try {
    const res = await LocationNumbersService.liftLocationSuspension(
      locationId
    )
    commit("setLocationBlackListConfig", res)
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}


export default liftLocationSuspension
